import { render, staticRenderFns } from "./Diseases.vue?vue&type=template&id=5384dc9e"
import script from "./Diseases.vue?vue&type=script&lang=js"
export * from "./Diseases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports